module.exports = __webpack_public_path__ + "img/google-fundamentals-of-digital-marketing.3ee49158.png";